import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'zip_code_protection-brand_blocked-action_unknown';

/**
 * Retailer was blocked from making a purchase due to zip code protection. This logs the blocked brand token and the reason
 */
export function trackZipCodeProtectionBrandBlocked(
  brandToken: string,
  Blocked_reason_code: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { brandToken, Blocked_reason_code },
  });
}
